import type {
  DocumentDataExtractorConfiguration,
  DocumentDataExtractorScreenConfiguration,
  GenericDocument,
  ImageInput,
  ResultWrapper,
} from '../types';
import {
  DocumentDataExtractionResult,
  DocumentDataExtractorUiResult,
  DocumentVerificationReport,
  handleImageInput,
  mapRTUUIResult,
  ToJsonConfiguration,
  withSBErrorHandling,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotDocumentDataExtractorImpl = {
  async extractFromImage(params: {
    image: ImageInput;
    configuration: DocumentDataExtractorConfiguration;
  }): Promise<DocumentDataExtractionResult> {
    return withSBErrorHandling(
      async () =>
        new DocumentDataExtractionResult(
          await ScanbotSDKPlugin.extractDocumentDataFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },

  async startExtractorScreen(
    configuration: DocumentDataExtractorScreenConfiguration,
  ): Promise<ResultWrapper<DocumentDataExtractorUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<DocumentDataExtractorUiResult>(
        await ScanbotSDKPlugin.startDDEScreen(configuration),
        DocumentDataExtractorUiResult,
      ),
    );
  },

  async forceCloseExtractorScreen(): Promise<void> {
    return withSBErrorHandling(ScanbotSDKPlugin.forceCloseDDEScreen);
  },

  async verifyDocument(documentParts: GenericDocument[]): Promise<DocumentVerificationReport> {
    const parts = (await Promise.all(
      documentParts.map((p) => p.serialize(new ToJsonConfiguration({ serializeImages: false }))),
    )) as GenericDocument[];

    return withSBErrorHandling(
      async () => new DocumentVerificationReport(await ScanbotSDKPlugin.verifyDocument({ documentParts: parts })),
    );
  },
};
